function RunsFormController(stateService, CommonService, toasterService, $uibModal) {
  const ctrl = this;
  const checkName = CommonService.checkName;

  ctrl.$onInit = () => {
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    stateService.getRunsAndRoutes(ctrl.workspaceId).then(data => {
      ctrl.routes = data.routes;
      ctrl.filteredRoutes = data.routes;
    });
    ctrl.firstRoute = true;
    if (!ctrl.selection) {
      ctrl.run = {
        name: null,
        description: null,
        stations: [],
        routes: [],
        variables: [],
      };
      ctrl.newRun = true;
      ctrl.viewMode = false;
    } else {
      ctrl.run = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
    }
  };

  ctrl.checkValidity = () => {
    return ctrl.newRun ? ctrl.run.routes.length === 0 || ctrl.duplicateName : ctrl.run.stations.length === 0 || ctrl.duplicateName;
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      // ctrl.currentScript = angular.copy(ctrl.script);
      ctrl.viewMode = false;
    } else {
      // Reapply the current script data if the user makes changes and presses 'Cancel'
      // ctrl.script = angular.copy(ctrl.currentScript);
      ctrl.run = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
    }
  };

  ctrl.checkDuplicate = () => {
    ctrl.duplicateName = checkName(ctrl.runs, ctrl.run);
  };

  ctrl.removeVariable = index => {
    ctrl.run.variables.splice(index, 1);
  };

  ctrl.openVariableModal = () => {
    let modalInstance = $uibModal.open({
      component: 'variableModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        workspaceId: () => ctrl.workspaceId,
        view: () => 'run'
      },
    });

    modalInstance.result.then(
      variableObject => {
        // User pressed 'Yes' in the modal.
        ctrl.run.variables.push(variableObject);
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.removeRoute = index => {
    ctrl.run.routes.splice(index, 1);
    if (ctrl.run.routes.length === 0) {
      ctrl.firstRoute = true;
      ctrl.filteredRoutes = ctrl.routes;
    } else {
      let lastRoute = _.last(ctrl.run.routes);
      ctrl.filteredRoutes = processRoutes(lastRoute, ctrl.routes);
    }
  };

  ctrl.clearForm = () => {
    ctrl.runForm.$setPristine(true);
    ctrl.runForm.$setUntouched(true);
    ctrl.duplicateName = false;
    ctrl.run = {
      name: null,
      description: null,
      stations: [],
      routes: [],
      variables: [],
    };
  };

  const processRoutes = (previous, list) => {
    if (!previous.reverse) { // If previous was added in default mode
      let filtered = [];
      _.each(previous.can_combine.normal, object => {
        let found = list.find(item => item.id === object.id);
        if (found) {
          found.normal = object.normal;
          filtered.push(found);
        }
      });
      return filtered;
    }  else { // If previous was added in reverse mode
      let filtered = [];
      _.each(previous.can_combine.reverse, object => {
        let found = list.find(item => item.id === object.id);
        if (found) {
          found.normal = object.normal;
          filtered.push(found);
        }
      });
      return filtered;
    }
  };
 
  ctrl.openRouteModal = () => {
    let modalInstance = $uibModal.open({
      component: 'routeModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        routes: () => ctrl.filteredRoutes,
        mode: () => ctrl.firstRoute,
      },
    });

    modalInstance.result.then(
      selectedRoute => {
        // User pressed 'Yes' in the modal.
        ctrl.run.routes.push(selectedRoute);
        ctrl.firstRoute = false;

        // Process routes list to remove ones that can't be combined with the previous selection
        ctrl.filteredRoutes = processRoutes(selectedRoute, ctrl.routes);
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  const buildStationList = routes => {
    let completeList = [];
    _.each(routes, route => {
      completeList.push(...route.stations);
    });
    return completeList;
  };

  ctrl.onSubmit = () => {
    // NEW RUN
    if (ctrl.newRun) {
      const REQ = {
        name: ctrl.run.name,
        description: ctrl.run.description,
        stations: buildStationList(ctrl.run.routes),
        variables: ctrl.run.variables
      };
      stateService.createRun(REQ, ctrl.workspaceId).then(
        function(response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-new-run-successful');
        },
        function(e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-new-run-failure');
          console.error(e);
        }
      );
    } else {
      // EDIT RUN
      const REQ = {
        name: ctrl.run.name,
        description: ctrl.run.description,
        stations: ctrl.run.stations,
        variables: ctrl.run.variables
      };
      stateService.editRun(ctrl.workspaceId, ctrl.run.id, REQ).then(
        function(response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-edit-run-successful');
        },
        function(e) {
          toasterService.error('toaster.pis-event', 'toaster.pis-edit-run-failure');
          console.error(e);
        }
      );
    }
  };
}

angular
  .module('pis-tool.module')
  .controller('RunsFormController', RunsFormController);
